import React from 'react'
import { SupportedScopesOperations } from "../../../../constants/TableData";
import { TextContent } from '../../../../shared/TextContent/TextContent';
import DynamicTable from '../../../../shared/DynamicTable/DynamicTable';

const Scopes = () => {
    return (
        <section id="scopes-section">
            <div className="section-container">
                <TextContent
                    header={"Supported Scope Definitions"}
                    description={`Below is the current list of supported <a href="https://build.fhir.org/ig/HL7/smart-app-launch/scopes-and-launch-context.html" target="_blank" rel='noopener'>scopes</a> in accordance with the HL7 FHIR standards`} />
                <div>
                    <DynamicTable
                        title={SupportedScopesOperations.table_header}
                        columns={SupportedScopesOperations.table_columns}
                        data={SupportedScopesOperations.table_data}
                    />
                </div>
            </div>
        </section>
    )
}


export default Scopes;
